import React, { useState } from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import { Box } from '@mui/material';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import MainContent from './components/MainContent/index';
import UnderDevelopmentPage from '../../UnderDevelopmentPage';

const projects = [
    {
        value: 1,
        label: 'HRMS',
    },
    {
        value: 2,
        label: 'Payroll',
    },
    {
        value: 3,
        label: 'Inventory',
    },
    {
        value: '4',
        label: 'Project Management'
    }
]

const modules = {
    id: 1,
    name: "HRMS",
    subModules: [
        {
            id: 1,
            name: "Login",
        },
        {
            id: 2,
            name: "Employee Management",
        },
        {
            id: 3,
            name: "Leave Management",
        },
        {
            id: 4,
            name: "Payroll",
        },
        {
            id: 5,
            name: "Attendance Tracking",
        },
        {
            id: 6,
            name: "Performance Review",
        },
        {
            id: 7,
            name: "Recruitment",
        },
        {
            id: 8,
            name: "Training & Development",
        },
        {
            id: 9,
            name: "Expense Management",
        },
        {
            id: 10,
            name: "Reports & Analytics",
        },
    ],
};

const TestCaseCreation = () => {
    const [project, setProject] = useState('');
    const [projectList, setProjectList] = useState(projects);
    const [projectModules, setProjectModules] = useState(modules);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedId, setSelectedId] = useState(null);
    const open = Boolean(anchorEl);
    const [openAddTestCase, setOpenAddTestCase] = useState(false);
    const [testCaseData, setTestCaseData] = useState({
        title: '',
        description: '',
        preconditions: '',
        owner: '',
        priority: '',
        testCaseState: '',
        testCaseType: '',
        automationStatus: '',
    });
    const [steps, setSteps] = useState([{ step: '', result: '' }]);
    const [selectedModule, setSelectedModule] = useState(null);


    const handleListClick = (id) => {
        setSelectedModule(id);
    };

    const handleAddStep = () => {
        setSteps([...steps, { step: '', result: '' }]);
    };

    const handleStepChange = (index, field, value) => {
        const updatedSteps = [...steps];
        updatedSteps[index][field] = value;
        setSteps(updatedSteps);
    };

    const handleDeleteStep = (indexToDelete) => {
        const updated = steps.filter((_, index) => index !== indexToDelete);
        setSteps(updated);
    };

    const handleMenuOpen = (event, subModuleId) => {
        setAnchorEl(event.currentTarget);
        setSelectedId(subModuleId);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleAddTestCase = () => {
        setOpenAddTestCase(true);
    };

    const handleProjectChange = (selectedProject) => {
        setProject(selectedProject);
    };

    return (
        <DashboardLayout>
            {/* <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '70vh',
                    width: '100%',
                }}>
                <Navbar />
                <Box sx={{ display: 'flex', flex: 1, }}>

                    <Sidebar project={project} handleProjectChange={handleProjectChange} projectList={projectList} projectModules={projectModules} anchorEl={anchorEl} handleMenuOpen={handleMenuOpen} handleAddTestCase={handleAddTestCase} open={open} handleMenuClose={handleMenuClose} openAddTestCase={openAddTestCase} setOpenAddTestCase={setOpenAddTestCase} testCaseData={testCaseData} steps={steps} setSteps={setSteps} handleAddStep={handleAddStep} handleStepChange={handleStepChange} handleDeleteStep={handleDeleteStep} handleListClick={handleListClick} />

                    <MainContent openAddTestCase={openAddTestCase} setOpenAddTestCase={setOpenAddTestCase} testCaseData={testCaseData} steps={steps} setSteps={setSteps} handleAddStep={handleAddStep} handleStepChange={handleStepChange} handleDeleteStep={handleDeleteStep} handleAddTestCase={handleAddTestCase}/>

                </Box>
            </Box> */}

            <UnderDevelopmentPage />

        </DashboardLayout>
    )
}

export default TestCaseCreation
